import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TerritoriesFilters, TerritoriesFiltersSelected } from '../../../../Models/TerritoriesFilters';
import { TerritoryRouteTypeAcronymDisplayEnum, TerritoryRouteTypeEnum } from '../../../../utilities/enums/TerritoriesEnum';

@Component({
  selector: 'app-territories-filter-popup',
  templateUrl: './territories-filter-popup.component.html',
  styleUrls: ['./territories-filter-popup.component.css']
})
export class TerritoriesFilterPopupComponent {

  territoryRouteTypeAcronymDisplayEnum = TerritoryRouteTypeAcronymDisplayEnum;
  territoryRouteTypeEnum = TerritoryRouteTypeEnum;
  
  //para el filtro de tipo de ruta hardcodeado
  isRouteTypeSelected: boolean = false;
  filterRouteTypeOptions = [
    {
      name: this.territoryRouteTypeAcronymDisplayEnum.FR,
      shortName: this.territoryRouteTypeEnum.Furia_Roja,
      dias: ["L", "M", "X", "J", "V", "S", "D", "W"],
      frecuencias: ["M1", "M2", "M3", "M4", "Q1", "Q2", "S1", "S2", "S3", "S4", "S"]
    },
    {
      name: this.territoryRouteTypeAcronymDisplayEnum.P,
      shortName: this.territoryRouteTypeEnum.Preventa,
      dias: ["L", "M", "X", "J", "V", "S", "D", "W"],
      frecuencias: ["Q1", "Q2", "S1", "S2", "S3", "S4", "S"]
    },
    {
      name: this.territoryRouteTypeAcronymDisplayEnum.REP,
      shortName: this.territoryRouteTypeEnum.Reparto,
      dias: ["L", "M", "X", "J", "V", "S", "D", "W"],
      frecuencias: ["S1", "S2", "S3", "S4", "S"]
    },
    {
      name: this.territoryRouteTypeAcronymDisplayEnum.AUT_FORANEA,
      shortName: this.territoryRouteTypeEnum.AUT_FORANEA,
      dias: ["L", "M", "X", "J", "V", "S", "D", "W"],
      frecuencias: ["M1", "M2", "M3", "M4", "Q1", "Q2", "S1", "S2", "S3", "S4", "S"]
    },
    {
      name: this.territoryRouteTypeAcronymDisplayEnum.AUT_LOCAL,
      shortName: this.territoryRouteTypeEnum.AUT_LOCAL,
      dias: ["L", "M", "X", "J", "V", "S", "D", "W"],
      frecuencias: ["M1", "M2", "M3", "M4", "Q1", "Q2", "S1", "S2", "S3", "S4", "S"]
    },
    {
      name: this.territoryRouteTypeAcronymDisplayEnum.LM,
      shortName: this.territoryRouteTypeEnum.LM,
      dias: ["L", "M", "X", "J", "V", "S", "D", "W"],
      frecuencias: ["M1", "M2", "M3", "M4", "Q1", "Q2", "S1", "S2", "S3", "S4", "S"]
    },
    {
      name: this.territoryRouteTypeAcronymDisplayEnum.RETAIL,
      shortName: this.territoryRouteTypeEnum.RETAIL,
      dias: ["L", "M", "X", "J", "V", "S", "D", "W"],
      frecuencias: ["M1", "M2", "M3", "M4", "Q1", "Q2", "S1", "S2", "S3", "S4", "S"]
    },
  ];
  DiaVisitaFilteredByRouteType: string[] = [];
  FrecuenciaRutaFilteredByRouteType: string[] = [];
  zonesByIdRegion: { description: string, idRegion: number }[] = [];


  filterData: TerritoriesFilters = {
    Regiones: [],
    Zonas: [],
    TipoRuta: [],
    DiaVisita: [],
    FrecuenciaRuta: []
  };

  selectedFilters: TerritoriesFiltersSelected = {
    Region: { description: "", id: 0 },
    Zona: { description: "", idRegion: 0 },
    TipoRuta: [],
    DiaVisita: [],
    FrecuenciaRuta: []
  };

  resultFilters: { search: boolean, selectedFilters: TerritoriesFiltersSelected } = {
    search: false,
    selectedFilters: null
  };

  isRegionDropdownOpen: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<TerritoriesFilterPopupComponent>,
    private toastService: ToastrService,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    if (data?.filterData) {
      const regiones = data.filterData.Regiones.map(region => ({ description: region.description, idRegion: region.id }));
      const zonas = data.filterData.Zonas.map(zone => ({ description: zone.description, idRegion: zone.idRegion }));

      this.filterData = {
        Regiones: regiones,
        Zonas: zonas,
        TipoRuta: data.filterData.TipoRuta,
        DiaVisita: data.filterData.DiaVisita,
        FrecuenciaRuta: data.filterData.FrecuenciaRuta
      };
    }
    if (data?.selectedFilters) {
      this.selectedFilters = {
        Region: data.selectedFilters.Region || { description: "", id: 0 },
        Zona: data.selectedFilters.Zona || { description: "", idRegion: 0 },
        TipoRuta: [...(data.selectedFilters.TipoRuta || [])],
        DiaVisita: [...(data.selectedFilters.DiaVisita || [])],
        FrecuenciaRuta: [...(data.selectedFilters.FrecuenciaRuta || [])]
      };

      if(this.selectedFilters.Region.id !== 0){
        this.zonesByIdRegion = this.filterData.Zonas.filter(zona => zona.idRegion === this.selectedFilters.Region.id);
      }

      if(this.selectedFilters.TipoRuta.length > 0){
        this.isRouteTypeSelected = true;
        this.updateFilteredOptionsForSelectedRouteTypes();
      }
    }
  }

  toggleRegionDropdown(): void {
    this.isRegionDropdownOpen = !this.isRegionDropdownOpen;
  }

  selectRegion(region: { description: string, idRegion: number }): void {
    if(region !== null && region !== undefined){
      this.selectedFilters.Region.description = region.description;
      this.selectedFilters.Region.id = region.idRegion;
      this.isRegionDropdownOpen = false;
      this.zonesByIdRegion = this.filterData.Zonas.filter(zona => zona.idRegion === region.idRegion);
    }else{
      this.selectedFilters.Region = { description: "", id: 0 };
      this.isRegionDropdownOpen = false;
      this.zonesByIdRegion = [];
    }
    
  }

  selectZona(zona: { description: string, idRegion: number }): void {
    if(zona !== null && zona !== undefined){
      this.selectedFilters.Zona.description = zona.description;
      this.selectedFilters.Zona.idRegion = zona.idRegion;
    }else{
      this.selectedFilters.Zona = { description: "", idRegion: 0 };
    }
  }

  selectTipoRuta(tipo: string): void {
    if(tipo !== "" && tipo !== null){
      const index = this.selectedFilters.TipoRuta.indexOf(tipo);
      
      if(index === -1){
        this.selectedFilters.TipoRuta.push(tipo);
        this.isRouteTypeSelected = true;
        
        this.updateFilteredOptionsForSelectedRouteTypes();
      } else {
        this.selectedFilters.TipoRuta.splice(index, 1);
        
        if(this.selectedFilters.TipoRuta.length === 0){
          this.isRouteTypeSelected = false;
          this.DiaVisitaFilteredByRouteType = [];
          this.FrecuenciaRutaFilteredByRouteType = [];
          this.selectedFilters.DiaVisita = [];
          this.selectedFilters.FrecuenciaRuta = [];
        } else {
          this.updateFilteredOptionsForSelectedRouteTypes();
          this.cleanInvalidSelectedOptions();
        }
      }
    }
  }

  updateFilteredOptionsForSelectedRouteTypes(): void {
    const allDias = new Set<string>();
    const allFrecuencias = new Set<string>();
    
    this.selectedFilters.TipoRuta.forEach(tipo => {
      const routeType = this.filterRouteTypeOptions.find(option => option.shortName === tipo || option.name === tipo);
      if(routeType){
        routeType.dias.forEach(dia => {
          if(this.filterData.DiaVisita.includes(dia)){
            allDias.add(dia);
          }
        });
        routeType.frecuencias.forEach(frec => {
          if(this.filterData.FrecuenciaRuta.includes(frec)){
            allFrecuencias.add(frec);
          }
        });
      }
    });
    
    this.DiaVisitaFilteredByRouteType = Array.from(allDias);
    this.FrecuenciaRutaFilteredByRouteType = Array.from(allFrecuencias);
  }

  cleanInvalidSelectedOptions(): void {
    this.selectedFilters.DiaVisita = this.selectedFilters.DiaVisita.filter(dia => 
      this.DiaVisitaFilteredByRouteType.includes(dia)
    );
    
    this.selectedFilters.FrecuenciaRuta = this.selectedFilters.FrecuenciaRuta.filter(frec => 
      this.FrecuenciaRutaFilteredByRouteType.includes(frec)
    );
  }

  toggleDiaVisita(dia: string): void {
    const index = this.selectedFilters.DiaVisita.indexOf(dia);
    if (index > -1) {
      this.selectedFilters.DiaVisita.splice(index, 1);
    } else {
      this.selectedFilters.DiaVisita.push(dia);
    }
  }

  toggleFrecuencia(frec: string): void {
    const index = this.selectedFilters.FrecuenciaRuta.indexOf(frec);
    if (index > -1) {
      this.selectedFilters.FrecuenciaRuta.splice(index, 1);
    } else {
      this.selectedFilters.FrecuenciaRuta.push(frec);
    }
  }

  onClose(): void {
    this.resultFilters.search = false;
    this.resultFilters.selectedFilters = null;
    this.dialogRef.close(this.resultFilters);
  }

  onClear(): void {
    this.resultFilters.search = true;
    this.resultFilters.selectedFilters = {
      Region: { description: "", id: 0 },
      Zona: { description: "", idRegion: 0 },
      TipoRuta: [],
      DiaVisita: [],
      FrecuenciaRuta: []
    };
    this.dialogRef.close(this.resultFilters);
  }

  onSearch(): void {
    if(this.selectedFilters.Region.description === "" && this.selectedFilters.Zona.description === "" && this.selectedFilters.TipoRuta.length === 0 && this.selectedFilters.DiaVisita.length === 0 && this.selectedFilters.FrecuenciaRuta.length === 0){
      this.toastService.warning("Selecciona al menos un filtro para realizar la búsqueda.", "Filtros Vacíos");
      return;
    }
    console.log("filtros", this.selectedFilters);
    
    this.resultFilters.search = true;
    this.resultFilters.selectedFilters = { ...this.selectedFilters };
    this.dialogRef.close(this.resultFilters);
  }
}
